
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import BaseFilterableContainer from './BaseFilterableContainer.vue';
import BaseFilterable from './BaseFilterable.vue';
import DataInfo from '@/components/reports-v3/components/elements/DataInfo.vue';

@Component({
	components: {
		BaseFilterable,
		DataInfo,
	},
})
export default class BasicDisplayerFilterable extends BaseFilterableContainer {}
